<div class="stat-list mt-4" [class.profile-stats]="isProfileView">
  @for (stat of statList; track stat) {
    <div class="stat-list-element small-box d-flex flex-column align-items-center py-3"
      >
      <div class="stat-list-image">
        <img [src]="stat.image" alt="">
      </div>
      <div class="stat-list-wrapper pt-0 d-flex flex-column justify-content-between align-items-center">
        <div>{{ stat.header_text }}</div>
        <div>{{ (stat.stat || 0)| number : '1.0-2' }}</div>
      </div>
    </div>
  }
</div>
